var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconionPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 109.215,
    viewBox: "0 0 100 109.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ion-person",
    "data-name": "Icon ion-person",
    d: "M71.8,10.192A24.577,24.577,0,0,0,53.375,2.25a24.639,24.639,0,0,0-18.461,7.894,26.035,26.035,0,0,0-6.461,19.693c1.067,14.9,12.247,27.021,24.922,27.021S77.21,44.739,78.295,29.841A25.957,25.957,0,0,0,71.8,10.192ZM95.681,111.465H11.068a7.409,7.409,0,0,1-5.817-2.713,8.7,8.7,0,0,1-1.726-7.1A41.77,41.77,0,0,1,21.837,73.922a56.76,56.76,0,0,1,31.538-9.264,56.779,56.779,0,0,1,31.538,9.264,41.76,41.76,0,0,1,18.312,27.73,8.7,8.7,0,0,1-1.726,7.1A7.409,7.409,0,0,1,95.681,111.465Z",
    transform: "translate(-3.375 -2.25)",
    fill: "#fefefe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionPerson);
export default __webpack_public_path__ + "static/media/Icon ion-person.781db71d25c3fe4835102633d8456bf1.svg";
export { ForwardRef as ReactComponent };